// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bas_a"};